export default class StreamStateManager {
    static DEFAULT_STATE = {
        info: 'Initiating...',
        error: '',
        freezed: false,
        isLoading: true,
    };

    #streamState;
    #initialState;
    #isAudioEnabled = false;
    #eventDispatcher;
    #logger;

    constructor(logger, customInitialState = null) {
        this.#initialState = customInitialState || StreamStateManager.DEFAULT_STATE;
        this.#streamState = { ...this.#initialState };
        this.#logger = logger;
    }

    setEventDispatcher(eventDispatcher) {
        this.#eventDispatcher = eventDispatcher;
    }

    updateState(detail, videoOutputId) {
        this.#streamState = {
            ...(this.#streamState && { ...this.#streamState }),
            ...detail,
            audioEnabled: this.#isAudioEnabled,
        };

        this.#logger(`StreamState updated:`, this.#streamState);

        // Dispatch through EventDispatcher
        if (this.#eventDispatcher) {
            this.#eventDispatcher.dispatchStreamState(this.#streamState, videoOutputId);
        }

        return this.#streamState;
    }

    updateStateOnly(detail) {
        this.#streamState = {
            ...(this.#streamState && { ...this.#streamState }),
            ...detail,
            audioEnabled: this.#isAudioEnabled,
        };
        return this.#streamState;
    }

    getCurrentState() {
        return { ...this.#streamState };
    }

    reset() {
        this.#streamState = { ...this.#initialState };
        this.#logger(`StreamState reset to initial state`);
        return this.#streamState;
    }

    setAudioEnabled(enabled) {
        this.#isAudioEnabled = enabled;
        // Automatically update and dispatch the state change
        this.updateState({ audioEnabled: enabled });
    }

    isAudioEnabled() {
        return this.#isAudioEnabled;
    }

    setLoading(isLoading) {
        this.updateState({ isLoading });
    }

    setError(error) {
        this.updateState({ error });
    }

    setFrozen(frozen) {
        this.updateState({ info: '', freezed: frozen });
    }

    setInfo(info) {
        this.updateState({ info });
    }
}
